import { defineMessages } from 'react-intl';

export default defineMessages({
    titleSingular: {
        id: '_.funding_requirements.id_check_verification.titleSingular',
        defaultMessage: 'Complete an identity check'
    },
    captionSingular: {
        id: '_.funding_requirements.id_check_verification.captionSingular',
        defaultMessage: 'Send yourself a SMS to do this.'
    },
    action: {
        id: '_.funding_requirements.onfido_action',
        defaultMessage: 'Send SMS'
    },
    pending: {
        id: '_.funding_requirements.onfido_action_pending',
        defaultMessage: 'Pending'
    }
});
